<template>
  <div>
    <div class="Banner">
      <img class="banner" src="../../assets/xtjclfw_banner.png" alt="">
    </div>
    <div class="container">
      <div class="title">
        <h1>
          ICT系统集成类服务
        </h1>
        <aside>
          ICT system integration service
        </aside>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <p>
            <img class="text_img" src="../../assets/Integration_service_pic.jpg" alt="">
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ICT业务是悦享互联通过运营商的传输网络为大客户所提供的重要业务。ICT业务包括：软硬件系统集成、设备供货  、物联网方案、灾备等应用业务。
            </span>
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为北京移动、北京电信等客户提供了视频会议、云安全等ICT服务。<br>
            <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们就ICT具体可开展的业务作初步分析。主要包括以下几点：</b><br>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.集成服务业务。指为客户提供软、硬件系统集成工程实施服务，包括项目和方案
            方案设计，软硬件采购、安装、和维保服务等。行业应用集成主要专注于医疗诊断物联网、运输物流物联网、制造业物联网、智能设备等行业应用等集成服务。
            </span><br>

            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.外包服务业务。针对细分市场的特定需求，整合内外部资源，为客户提供日常运行维护、故障处理以及运行管理服务等。</span><br>

            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.专业服务。为客户提供从网络通信到网络应用、行业应用的整体服务业务，主要包括：系统灾备服务业务、管理型业务、应用平台业务。</span><br>

            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.知识服务。以为客户创造价值为目标，通过与有优势的技术、业务、管理专家团队合作，为客户提供系统规划、业务优化咨询、安全咨询及评估、物联网设备连接与管理等应用系统的规划和优化、业务流程规划、IT 系统规划、IT 系统测试及风险评估、业务连续性及灾备策略咨询、各类培训等服务。</span>
            <br>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.软件开发服务。是指向客户销售具有自主知识产权的相关的软件产品和服务。</span><br>
          </p>
        </div>
      </div>
    </div>
    <br>
    <br>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    props: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner{
    width: 100%;
  }
  .text_img {
    width: 100%;
    margin-bottom: 30px;
  }
  .Banner {
    margin-bottom: 4rem;
  }
  h1 {
    font-size: 4.6rem;
    color: #fe9901;
  }
  aside {
    font-size: 1.6rem;
    color: #999;
    text-transform: uppercase;
  }
  .title {
    padding-left: 30px;
    border-left: 1px solid #ccc;
    margin-bottom: 4rem;
  }
  p {
    color: #333;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 30px;
  }
  @media (min-width: 769px) {

    .text_img {
      width: auto;
      float: left;
      margin-right: 40px;
      margin-bottom: 20px;
    }
  }
</style>
